import { useEffect } from "react";
import { useRouter } from "next/router";

// Simple redirect component that redirects to /welcome
export default function WelcomeDialog() {
  const router = useRouter();

  useEffect(() => {
    router.push("/welcome");
  }, [router]);

  return null;
}
